import './styles.scss'

interface CategoryTitleProps {
  name: string
  onClick?: () => void
}

function CategoryTitle({ name, onClick }: CategoryTitleProps) {
  return (
    <button
      className="header-menu-drawer__title-button"
      type="button"
      onClick={onClick}
    >
      {name}
    </button>
  )
}

export default CategoryTitle
